export default function log({ next }) {
  return next();
}
